var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.noLazy)?_c('v-lazy-image',{attrs:{"src":_vm.itemImage,"src-placeholder":require('@/assets/img/item-placeholder.svg'),"alt":_vm.item?.market_hash_name}}):_c('img',{attrs:{"src":_vm.itemImage,"alt":_vm.item?.market_hash_name}})
}
var staticRenderFns = []

export { render, staticRenderFns }